<template>
  <div class="more-features">
    <Background class="more-features__background" />
    <Heading size="h2">
      {{ $t('pages.ssr_features.pages.common.more_features.title') }}
    </Heading>
    <ul class="more-features__list">
      <li
        v-for="(feature, index) in features"
        :key="index"
        class="more-features__list-el"
      >
        <component :is="cards[feature]" />
      </li>
    </ul>
  </div>
</template>

<script>
import Background from './svg/Background'
import AnalyticsCard from './cards/AnalyticsCard.vue'
import CollaboratorsCard from './cards/CollaboratorsCard.vue'
import DistributionCard from './cards/DistributionCard.vue'
import EmbeddablePlayerCard from './cards/EmbeddablePlayerCard.vue'
import HostingCard from './cards/HostingCard.vue'
import MonetizationCard from './cards/MonetizationCard.vue'
import Podcasting20 from './cards/Podcasting20.vue'
import PodvizCard from './cards/PodvizCard.vue'
import PrivacyCard from './cards/PrivacyCard.vue'
import SocialMediaSharingCard from './cards/SocialMediaSharingCard.vue'
import TranscriptCard from './cards/TranscriptCard.vue'
import WebsiteCard from './cards/WebsiteCard.vue'
import Heading from '@/components/common/Heading/Heading.vue'

export default {
  components: {
    Heading,
    AnalyticsCard,
    DistributionCard,
    MonetizationCard,
    Background
  },

  props: {
    features: {
      type: Array,
      default: () => []
    }
  },

  data () {
    return {
      cards: {
        analytics: AnalyticsCard,
        collaborators: CollaboratorsCard,
        distribution: DistributionCard,
        embeddable: EmbeddablePlayerCard,
        hosting: HostingCard,
        monetization: MonetizationCard,
        podcasting20: Podcasting20,
        podviz: PodvizCard,
        privacy: PrivacyCard,
        social: SocialMediaSharingCard,
        transcript: TranscriptCard,
        website: WebsiteCard
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.more-features {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: $gap * 5 $gap;
  gap: $gap * 2;
  background-color: #25163A;
  overflow: hidden;

  &__background {
    position: absolute;
    bottom: 0;
    right: 0;
  }

  &__list {
    max-width: 1120px;
    display: flex;
    flex-direction: row;
    gap: $gap;

    @include display-less(desktop) {
      flex-direction: column;
    }

    &-el {
      flex: 1;
    }
  }
}
</style>
